import { datadogLogs } from "@datadog/browser-logs";

export const initDatadogLogs = () => {
    if (import.meta.env.VITE_NODE_ENV !== "production") return;

    datadogLogs.init({
        // see https://app.datadoghq.com/organization-settings/client-tokens
        // cpot-ces
        clientToken: "pubfe8029ba403a219852961b1db3a414c5",
        site: "datadoghq.com",
        forwardErrorsToLogs: true,
        env: import.meta.env.VITE_NODE_ENV,
        service: "ces2",
        version: import.meta.env.VITE_COMMIT_HASH,
        beforeSend: (log) => {
            // ネットワークエラーのログはDatadogに送信しない
            if (log.origin === "network" && log.status === "error") {
                return false;
            }
            return true;
        },
    });
};

// ErrorBoundary が捕捉した 500 / 想定外エラー (クラッシュ) を構造化ログとして送る。 forwardErrorsToLogs は
// error の message/stack しか拾わず、 requestId 等の独自属性や loader/action 由来の捕捉済みエラーを
// 取りこぼすため、 ここで requestId 等を context に乗せて明示送信する。 init 前 (dev 等) は SDK 側で無視される。
export const logError = (error: unknown, context: Record<string, unknown> = {}) => {
    if (import.meta.env.VITE_NODE_ENV !== "production") return;
    const message = error instanceof Error ? error.message : String(error);
    datadogLogs.logger.error(message, context, error instanceof Error ? error : undefined);
};
